import Alert from "../alert/alert"
import { Drawer as AntdDrawer } from "antd"

const Drawer = ({ error, footer, ...rest }) => {
  return (
    <AntdDrawer
      footer={
        <>
          {error && (
            <Alert
              className="mbe-16"
              style={{ marginInline: -32, marginBlockStart: -20, textAlign: "start" }}
              banner
              type="error"
              showIcon
              {...error}
            />
          )}
          {footer}
        </>
      }
      {...rest}
    />
  )
}
export default Drawer
